// extracted by mini-css-extract-plugin
export default {"label":"Form_label__zKivR","input":"Form_input__Ze0Xa"};